// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a66e75f6","732":"9fda487d","762":"3e84c3ec","971":"d9bdca7b","977":"e8edbf1c"}[chunkId] + ".chunk.js";
};